<kendo-dropdownlist *ngIf="BindingProperty"
                    [data]="FilterData"
                    [textField]="TextField"
                    [valueField]="ValueField"
                    [defaultItem]="DefaultItem"
                    [valuePrimitive]="true"
                    [disabled]="IsDisabled"
                    [formControl]="BindingProperty"
                    (valueChange)="valueChange($event)"
                    (selectionChange)="selectionChange($event)"
                    (focus)="focus()"
                    (open)="open()"
                    [filterable]="IsFilterable"
                    (filterChange)="handleFilter($event)"
                    [ngClass]="{'dropdown-large': styleType === 'large', 'dropdown-medium': styleType === 'medium','': styleType === 'none'}"
                    [id]="DomId || Name"
                    [style]="style"
                    #bindingDrop>
  <ng-template *ngIf="title" kendoDropDownListValueTemplate>
    {{title}}
  </ng-template>

  <ng-template *ngIf="HasStatuesIcon" kendoDropDownListItemTemplate let-dataItem>
    <span [style]="{'background':dataItem.StatusColor?dataItem.StatusColor:'#000000'}" class="template"></span> {{ dataItem.text }}
  </ng-template>
</kendo-dropdownlist>

<kendo-dropdownlist
*ngIf="!BindingProperty"
[data]="FilterData" 
[textField]="TextField"
[valueField]="ValueField"
[defaultItem]="DefaultItem"
[(ngModel)]="SelectedRow"
[valuePrimitive]="true" 
(open)="open()"
[disabled]="IsDisabled"
(valueChange)="valueChange($event)"
(selectionChange)="selectionChange($event)"
[filterable]="IsFilterable"
(filterChange)="handleFilter($event)"
[style]="style"
[ngClass]="{'dropdown-large': styleType === 'large', 'dropdown-medium': styleType === 'medium','': styleType === 'none'}"
#nonBindingDrop
>
<ng-template *ngIf="title" kendoDropDownListValueTemplate>
   {{title}}
</ng-template>

<ng-template *ngIf="HasStatuesIcon" kendoDropDownListItemTemplate let-dataItem>
  <span [style]="{'background':dataItem.StatusColor?dataItem.StatusColor:'#000000'}" class="template"></span> {{ dataItem.text }}
</ng-template>
</kendo-dropdownlist>
